export default __webpack_public_path__ + "static/media/cesto_mirtilli.aa3ace07.svg";